module.exports = __webpack_public_path__ + "img/COM.502d55a1.png";